import React, { CSSProperties, HTMLProps } from "react"

import classNames from "classnames"

import { DataTableCell } from "shared/types/__generated__/graphql"

export interface DataTableRowProps
  extends Omit<HTMLProps<HTMLTableRowElement>, "onSelect" | "ref"> {
  row: DataTableCell[] | null | undefined
  className?: string
  cellStyle?: CSSProperties
}

export const DataTableRow = React.memo(
  React.forwardRef(
    (
      { row, className, cellStyle, ...rest }: DataTableRowProps,
      ref?: React.ForwardedRef<HTMLTableRowElement>
    ) => (
      <tr
        className={classNames("data-table__row", className)}
        ref={ref}
        {...rest}
      >
        {row?.map(cell => (
          <td
            key={cell.index}
            style={cellStyle}
            className={classNames("data-table__cell", cell.className)}
          >
            <div className="data-table__cell-content">{cell.value}</div>
          </td>
        ))}
      </tr>
    )
  )
)
